module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Other-791e4cf40cbfb9ed114bee9c20389793.png";